// extracted by mini-css-extract-plugin
module.exports = {"root":"medical-prescription-form_root__1VC_g"};